import { render, staticRenderFns } from "./Civil.vue?vue&type=template&id=34803106&scoped=true"
import script from "./Civil.vue?vue&type=script&lang=ts"
export * from "./Civil.vue?vue&type=script&lang=ts"
import style0 from "./Civil.vue?vue&type=style&index=0&id=34803106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34803106",
  null
  
)

export default component.exports